var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"has-tooltip inline-block"},[_c('span',{ref:"tooltip",staticClass:"tooltip rounded-xl shadow-lg p-2 bg-white border-primary-300 border text-gray-800 -mt-11"},[_vm._t("tooltip")],2),_vm._v(" "),_c('p',{ref:"text"},[_vm._t("text")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }